module.exports = "/assets/data/c2f7d842081b7c458e29217acabd2ec0-KA3.data.json";